export default "__VITE_ASSET__BFJCoTSl__"